import { HttpErrorResponse } from '@angular/common/http';

import { environment } from '@env/environment';

import type { ErrorOrigin, ErrorReport, NeverSentRule } from './error-report.types';

export const NEVER_SENT: readonly NeverSentRule[] = [
  { name: 'token', pattern: /\bBearer\s+[A-Za-z0-9._~+/=-]+/gi },
  { name: 'cabeçalho de autorização', pattern: /\b(?:authorization|proxy-authorization|x-api-key|api-key)\b"?\s*[:=]\s*"?[^\s,;}"]+/gi },
  { name: 'senha', pattern: /\b(?:senha|password|passwd|pwd|secret|pepper)\b"?\s*[:=]\s*"?[^\s,;}"]+/gi },
  { name: 'token', pattern: /\b(?:token|jwt|access_token|accesstoken|refresh_token|refreshtoken|id_token|apikey|api_key|authkey)\b"?\s*[:=]\s*"?[^\s,;}"&]+/gi },
  { name: 'token de recuperação', pattern: /(?<=\/(?:change-password|passwordrecovery\/validate)\/)[^\s/?#]+/gi },
  { name: 'documento', pattern: /\b\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}\b|\b\d{3}\.?\d{3}\.?\d{3}-?\d{2}\b/g },
  { name: 'telefone', pattern: /(?:\+\d{1,3}\s?)?\(?\d{2}\)?[\s.-]?9?\d{4}[\s.-]\d{4}\b/g },
  { name: 'e-mail', pattern: /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g },
  { name: 'dado pessoal', pattern: /\b(?:nome|name|fullname|firstname|lastname|sobrenome|cpf|cnpj|birthdate|datanascimento)\b"?\s*[:=]\s*"?[^\s,;}"&]+/gi },
];

export function redactNeverSent(text: string): string {
  return NEVER_SENT.reduce((sanitized, rule) => sanitized.replace(rule.pattern, `[removido: ${rule.name}]`), text);
}

export function withoutQueryString(url: string): string {
  const cut = url.search(/[?#]/);

  return cut < 0 ? url : url.slice(0, cut);
}

export function toErrorReport(error: unknown, route: string, origin: ErrorOrigin): ErrorReport {
  return {
    origin,
    message: redactNeverSent(messageWithoutBodies(error)),
    stack: redactNeverSent(stackOf(error)),
    route: redactNeverSent(withoutQueryString(route)),
    environmentName: environment.name,
    occurredAt: new Date().toISOString(),
  };
}

function messageWithoutBodies(error: unknown): string {
  if (error instanceof HttpErrorResponse) {
    return `HTTP ${error.status} em ${withoutQueryString(error.url ?? '(sem url)')}`;
  }

  if (error instanceof Error) {
    return `${error.name}: ${error.message}`;
  }

  if (typeof error === 'string') {
    return error;
  }

  return 'Erro sem mensagem própria: o corpo do que foi lançado não é relatado.';
}

function stackOf(error: unknown): string {
  if (error instanceof Error && typeof error.stack === 'string') {
    return error.stack;
  }

  return '';
}
